import React from 'react';

export function BrandMark({
  className,
  height = 14,
}: {
  className?: string;
  height?: number;
}) {
  return (
    <svg
      aria-hidden
      className={className}
      height={height}
      viewBox="0 0 28 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.499 0 0 18.189l3.501 6.06L14 6.062 10.499 0Z"
        fill="#FE4497"
      />
      <path
        d="m10.499 0 10.499 18.189h-14L3.5 24.248h21L28 18.19 17.501 0H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
